export const formNameToId = (name: string): string => {
    return name.replace(/\./g, "_").replace(/\[/g, "_").replace(/\]/g, "_")
}